
import navBar from "@/components/nav/index.vue";
export default  {
  name: 'Header',
  components: {navBar},
  data() {
    return {
      activePath: '',
      navShow: false,
      isMenuOpen: false, // 菜单展开/收缩状态
    }
  },
  computed: {
    navBarList() {
      return [
        {path: '/', title: this.$t('nav.home'), fullPath: '/'},
        {path: '/klyr', title: this.$t('nav.KLYR'), fullPath: '/klyr'},
        {path: '/CBDC', title: this.$t('nav.CBDCSolution'), fullPath: '/CBDC'},
        {path: '/coreTech', title: this.$t('nav.coreTechnology'), fullPath: '/coreTech'},
        {path: '/productIntroduction', title: this.$t('nav.applicationIntroduction'), fullPath: '/applicationIntroduction'},
        {path: '/aboutUs', title: this.$t('nav.aboutUs'), fullPath: '/aboutUs'},
        {path: '/industry', title: this.$t('nav.industryInformation'), fullPath: '/industry'},
        {path: '/esg', title: this.$t('nav.ESG'), fullPath: '/esg'},
        // {path: '/investor', title: this.$t('nav.InvestorRelations'), fullPath: '/investor'},
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // 切换菜单展开/收缩状态
    },
    changeLanguage() {
      this.$i18n.setLocale(this.$i18n.locale === 'en' ? 'zh' : 'en')
    },
    getRouter(path) {
      const locale = this.$i18n.locale;
      const pre = (locale == 'en' ? '/en' : '');
      return pre + path;
    },
    leave() {
      this.navShow = false
    },
    mouseLeave() {

    },
    mouseEnter() {

    },
  }
}
